"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStreamsEvmOperation = void 0;
var common_core_1 = require("@moralisweb3/common-core");
var dataTypes_1 = require("../../dataTypes");
exports.getStreamsEvmOperation = {
    method: 'GET',
    name: 'getStreamsEvm',
    id: 'GetStreams',
    groupName: 'evmStreams',
    urlSearchParamNames: ['cursor', 'limit'],
    urlPathPattern: '/streams/evm',
    firstPageIndex: 0,
    getRequestUrlParams: getRequestUrlParams,
    deserializeResponse: deserializeResponse,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
};
// Methods
function getRequestUrlParams(request) {
    return {
        limit: (0, common_core_1.maybe)(request.limit, String),
        cursor: request.cursor,
    };
}
function deserializeResponse(jsonResponse, request, core) {
    var _a;
    return ((_a = jsonResponse.result) !== null && _a !== void 0 ? _a : []).map(function (stream) { return dataTypes_1.EvmStream.create(stream, core); });
}
function serializeRequest(request) {
    return {
        cursor: request.cursor,
        limit: request.limit,
    };
}
function deserializeRequest(jsonRequest) {
    return {
        cursor: jsonRequest.cursor,
        limit: jsonRequest.limit,
    };
}
//# sourceMappingURL=getStreamsEvmOperation.js.map